import { signal, useSignal } from "@preact/signals-react";
import { useNavigate } from "react-router";

import CreateControlAccess from "../CreateControlAccess";
import ApproveGroupAccess from "../ApproveGroupAccess";
import Board from "componentsv2/board/Board";
import Button from "componentsv2/button/Button";
import Dialog from "componentsv2/modal/Dialog";
import { layoutAccess } from "../ModelStaffAccess";
import { useLayout } from "hooks/layout";

const openCreate = signal(false);
const openApprove = signal(false);

const today = new Date();
today.setDate(today.getDate() + 1);

function ViewAssistance() {
  const navigate = useNavigate();
  const layout = useLayout(layoutAccess);
  const currentView = useSignal("list");

  function closeModal() {
    openCreate.value = false;
    openApprove.value = false;
  }

  async function openModal(action) {
    if (action === "create") {
      openCreate.value = true;
    } else if (action === "approve") {
      openApprove.value = true;
    }
  }

  const handlereturn = () => {
    navigate(-1);
  };

  return (
    <div className="w-full px-0!">
      <div className="flex flex-col w-full h-full min-h-auto bg-neutral-100 relative -mt-1">
        <Board
          layout={layout}
          returnFilter={handlereturn}
          currentView={currentView}
          style="min-h-auto h-auto! w-full !mb-5"
          showBackButton={true}
        />
      


        <div className="w-full bg-white border-t border-neutral-200 px-3 md:px-6 py-3 flex flex-row justify-center md:justify-end items-center gap-2 md:gap-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-20 shrink-0 mt-auto sticky bottom-0">
          <div className="hidden md:block mr-auto text-sm font-semibold text-neutral-400 uppercase tracking-wider">
            Acciones
          </div>
          <Button
            content="staff.access.create_shift_schedule"
            style="h-10 flex-1 md:flex-none md:w-fit px-2 md:px-6 shadow-sm rounded-lg font-medium text-amber-950 text-xs md:text-sm"
            onClick={() => openModal("create")}
            color="amber"
          />
          <Button
            content="staff.access.approve_group_access"
            style="h-10 flex-1 md:flex-none md:w-fit px-2 md:px-6 bg-sky-300 shadow-sm rounded-lg font-medium text-xs md:text-sm !border border-black"
            onClick={() => openModal("approve")}
            color="sky"
            outline={true}
          />
        </div>

        <Dialog
          title="staff.access.create_shift_schedule"
          openModal={openCreate}
          handleClose={closeModal}
        >
          <CreateControlAccess
            employeesAvailable
            onClose={closeModal}
            openModal={openCreate}
          />
        </Dialog>
        <Dialog
          title="staff.access.approve_group_access"
          openModal={openApprove}
          handleClose={closeModal}
        >
          <ApproveGroupAccess onClose={closeModal} openModal={openApprove} />
        </Dialog>
      </div>
    </div>
  );
}

export default ViewAssistance;
